export const ENV_API_POSTFIX = import.meta.env.VITE_API_POSTFIX || '';
export const ENV_SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || '';
export const ENV_NAME = import.meta.env.VITE_ENV_NAME || '';
export const ENV_CI_RELEASE = import.meta.env.TAG_SR || '';
export const ENV_SMARTLOOK_TOKEN = import.meta.env.VITE_SMARTLOOK_TOKEN || '';
export const ENV_ORDER_ASSETS_PAIRS = import.meta.env.VITE_ORDER_ASSETS_PAIRS || '';
export const ENV_DEMO_WIDGET_ASSET_CODE = import.meta.env.VITE_DEMO_WIDGET_ASSET_CODE || '';
export const ENV_DEMO_WIDGET_ASSET_ISSUER = import.meta.env.VITE_DEMO_WIDGET_ASSET_ISSUER || '';
export const ENV_SIFT_KEY = import.meta.env.VITE_SIFT_KEY || '';

export const IS_PRODUCTION = ENV_NAME === 'production';
export const IS_STAGE = ENV_NAME === 'stage';
export const IS_DEV = ENV_NAME === 'dev';
export const IS_LOCAL = ENV_NAME === 'local';

